var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
/**
 * Represents the footer of the column group.
 */
var ExcelExportGroupFooter = /** @class */ (function (_super) {
    __extends(ExcelExportGroupFooter, _super);
    function ExcelExportGroupFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ExcelExportGroupFooter;
}(React.PureComponent));
export default ExcelExportGroupFooter;
//# sourceMappingURL=ExcelExportGroupFooter.js.map